
const Button = ({ className = '', title, ...props }) => {
    return (
        <button
            type="button"
            className={`btn btn-primary d-flex align-items-center ${className}`}
            {...props}
        >
            {title || 'Click'}
        </button>
    )
}

export default Button